import { Injectable } from "@angular/core";
import { Router, CanActivate } from "@angular/router";
import { from, Observable, of } from "rxjs";

import { CacheService, AuthService } from "src/app/core/services";
import { catchError, map, switchMap } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class AuthGuardService implements CanActivate {
  constructor(
    public auth: AuthService,
    private cacheService: CacheService,
    public router: Router
  ) {}

  /**
   * canActivate method is to verify
   * if navigate or not
   * @returns {boolean}
   * @memberof AuthGuardService
   */
  canActivate(): boolean | Promise<boolean> | Observable<boolean> {
    const token = this.cacheService.get("token", "session");

    if (token) {
      if (this.auth.isUserLoggedIn) {
        return true;
      }

      return this.auth.getFirebaseIDToken().pipe(
        switchMap((_) => {
          return from(this.auth.loadUserDetails());
        }),
        map((res) => {
          return res.status_code === 200 ? true : false;
        }),
        catchError(() => {
          this.router.navigate(["/"]);
          return of(false);
        })
      );
    } else {
      this.router.navigate(["/"]);
      return false;
    }
  }
}
